// Length caps for inbox-entry (DoBox) free-text, shared by the web form (maxLength) and the
// API write guard. Description stays well under DynamoDB's 400KB item limit even encrypted.
export const DOBOX_SUBJECT_MAX_LENGTH = 200;
export const DOBOX_DESCRIPTION_MAX_LENGTH = 20_000;
// A spec body is a whole document; sealed it stays under DynamoDB's 400KB item limit (60k chars x 4B x 4/3 base64 = 320KB worst case).
export const SPEC_DESCRIPTION_MAX_LENGTH = 60_000;
export const TASK_SUBGROUP_TITLE_MAX_LENGTH = 60;
// Matches MAX_BATCH_ITEMS, the size `batchGet` chunks on, so hydrating an entry's links
// stays one round trip. Raising it past 25 makes that read serial, not wider.
export const MAX_RELATED_INBOX_ENTRIES = 25;
export const CHECKLIST_TITLE_MAX_LENGTH = 200;
export const CHECKLIST_SUBTASK_TITLE_MAX_LENGTH = 200;
export const MAX_CHECKLISTS_PER_ENTRY = 10;
// Entry-wide, not per-checklist, so one checklist may hold all 100 — splitting into smaller
// checklists spends the same budget. What sets the number is that `updateInboxEntry` rewrites
// the whole item inside a transaction, so every checkbox toggle pays for the entire entry:
// a sealed subtask costs ~350B (~600B in multi-byte text, which `.length` undercounts), and
// 100 of them beside a capped description put a toggle near 180 WCU rather than 300.
export const MAX_SUBTASKS_PER_ENTRY = 100;

// The web copy and the API query share this window.
export const AUTO_RESOLVED_SUGGESTIONS_WINDOW_DAYS = 3;
